"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.getNodeDefChildren = exports.getNodeDefSource = exports.getNodeDefRoot = exports.isNodeDefAncestor = exports.getNodeDefParent = exports.getNodeDefByUuid = exports.getNodeDefByName = void 0;
var utils_1 = require("../../utils");
var getNodeDefByName = function (params) {
    var survey = params.survey, name = params.name;
    var nodeDef = Object.values(survey.nodeDefs || {}).find(function (nodeDef) { return nodeDef.props.name === name; });
    if (!nodeDef)
        throw new Error("Node def with name ".concat(name, " not found in survey"));
    return nodeDef;
};
exports.getNodeDefByName = getNodeDefByName;
var getNodeDefByUuid = function (params) {
    var _a;
    var survey = params.survey, uuid = params.uuid;
    var nodeDef = (_a = survey.nodeDefs) === null || _a === void 0 ? void 0 : _a[uuid];
    if (!nodeDef)
        throw new Error("Node def with uuid ".concat(uuid, " not found in survey"));
    return nodeDef;
};
exports.getNodeDefByUuid = getNodeDefByUuid;
var getNodeDefParent = function (params) {
    var survey = params.survey, nodeDef = params.nodeDef;
    if (!nodeDef.parentUuid)
        return undefined;
    return (0, exports.getNodeDefByUuid)({ survey: survey, uuid: nodeDef.parentUuid });
};
exports.getNodeDefParent = getNodeDefParent;
var isNodeDefAncestor = function (params) {
    var nodeDefAncestor = params.nodeDefAncestor, nodeDefDescendant = params.nodeDefDescendant;
    return utils_1.Arrays.startsWith(nodeDefDescendant.meta.h, __spreadArray(__spreadArray([], nodeDefAncestor.meta.h, true), [nodeDefAncestor.uuid], false));
};
exports.isNodeDefAncestor = isNodeDefAncestor;
var getNodeDefRoot = function (params) {
    var survey = params.survey;
    if (!survey.nodeDefs)
        throw new Error('Empty node defs in survey');
    var rootDef = Object.values(survey.nodeDefs).find(function (nodeDef) { return !nodeDef.parentUuid; });
    if (!rootDef)
        throw new Error('Cannot find root def in survey');
    return rootDef;
};
exports.getNodeDefRoot = getNodeDefRoot;
var getNodeDefSource = function (params) {
    var survey = params.survey, nodeDef = params.nodeDef;
    return nodeDef.virtual ? (0, exports.getNodeDefParent)({ survey: survey, nodeDef: nodeDef }) : undefined;
};
exports.getNodeDefSource = getNodeDefSource;
var getNodeDefChildren = function (params) {
    var survey = params.survey, nodeDef = params.nodeDef, _a = params.includeAnalysis, includeAnalysis = _a === void 0 ? false : _a;
    if (!survey.nodeDefs)
        return [];
    var children = [];
    if (nodeDef.virtual) {
        var entitySource = (0, exports.getNodeDefSource)({ survey: survey, nodeDef: nodeDef });
        if (entitySource) {
            children.push.apply(children, (0, exports.getNodeDefChildren)({ survey: survey, nodeDef: entitySource }));
        }
    }
    children.push.apply(children, Object.values(survey.nodeDefs).filter(function (nodeDefCurrent) {
        if (!includeAnalysis && nodeDefCurrent.analysis) {
            return false;
        }
        if (nodeDefCurrent.virtual) {
            var entitySource = (0, exports.getNodeDefSource)({ survey: survey, nodeDef: nodeDefCurrent });
            if (entitySource) {
                return entitySource.parentUuid === nodeDef.uuid;
            }
        }
        return nodeDefCurrent.parentUuid === nodeDef.uuid;
    }));
    return children;
};
exports.getNodeDefChildren = getNodeDefChildren;
//# sourceMappingURL=nodeDefs.js.map